import React from 'react';
import { Button, Heading, Layout, Text } from '../../../../components/core';
import { getStylesheet } from '../../../../styles';

export const NotEligibleSurvey = ({ onExploreHub }: { onExploreHub: () => void }): JSX.Element => (
  <Layout.VStack space={4} {...styles.dashboardBox}>
    <Heading.h4 level={2}>Specific eligibility required</Heading.h4>
    <Text.para>
      Participation in this survey is limited to a select group of students at this time.
    </Text.para>
    <Text.para>
      While you're not eligible for this one, we appreciate your interest, and recommend that you
      explore the other resources available to you through Mantra Health!
    </Text.para>
    <Button.secondaryMedium isLink onPress={onExploreHub} testID="pressable-survey-explore-hub">
      Explore the Mantra Hub
    </Button.secondaryMedium>
  </Layout.VStack>
);

const styles = getStylesheet({
  dashboardBox: {
    backgroundColor: 'white',
    borderColor: 'secondary.200',
    borderRadius: 8,
    borderWidth: 1,
    gap: 6,
    justifyContent: 'space-between',
    overflow: 'hidden',
    padding: 6,
  },
});
